export const API_PARAM = {
  //TERMS AND CONDITIONS
  TERMS_ACCEPTED: "user-profile/terms-and-conditions/accepted",
  TERMS_CONTENT: "user-profile/terms-and-conditions",
  TERMS_ACCEPT: "user-profile/terms-and-conditions/accept",
  //PRIVACY POLICY
  PRIVACY_ACCEPTED: "user-profile/privacy-policy/accepted",
  PRIVACY_CONTENT: "user-profile/privacy-policy",
  PRIVACY_ACCEPT: "user-profile/privacy-policy/accept",
  //GRAPH
  GRAPH_USER: "core/graph/users",
  GRAPH_USER_PHOTO: "core/graph/users/photo",
  GRAPH_CURRENT_USER_PHOTO: "core/graph/users/photo/me",
};
